import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import LoadBox from '../../components/LazyBox';

//css
import './busca.css';

export default class Busca extends React.Component {

	expectedSearch = () => {
		const { lista, submitSearch } = this.props;
		const { search } = this.props.location;
		const busca = decodeURIComponent(search.replace("?s=",""));
		if( lista.length === 0 ){
			submitSearch(busca);
		}
	}

	componentDidMount(){
		this.expectedSearch();
	}

    render() {
		const { lista, loading } = this.props;
		const { search } = this.props.location;
		const busca = decodeURIComponent(search.replace("?s=",""));
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>Busca</title>
						<meta name="description" content="Helmet application" />
					</Helmet>
					{loading === false && <div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >{lista.length} RESULTADO(S) PARA '{busca}'</Typography>
						</div>
					</div>}
					<div className="app_content_page__row" >
						<LoadBox height="50vh" loading={loading} >
							<Grid container spacing={32} style={{paddingTop:50, paddingBottom:50}} >
								{lista.map((l,k) => <Grid item xs={12} key={k} className="row_item_search" >
										<Link to={l.url} >
											<Typography variant="h5" >{l.titulo}</Typography>
											<Typography variant="body1" >{l.descricao.replace(/<(.|\n)*?>/g, '').substring(0, 100)}</Typography>
										</Link>
								</Grid>)}
							</Grid>
						</LoadBox>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/busca/index.js